import { render, staticRenderFns } from "./NurseDetails.vue?vue&type=template&id=00093e8a&"
import script from "./NurseDetails.vue?vue&type=script&lang=js&"
export * from "./NurseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports